import service from '@/utils/request'

/** 获取供应商分页列表 */
export function getSupplierPages(params) {
  return service.get('/backend/supplier/page', { params })
}

/** 获取供应商列表 */
export function getSupplierList(params) {
  return service.get('/backend/supplier/list', { params })
}

/** 获取供应商详情 */
export function getDetail(id) {
  return service.get(`/backend/supplier/detail?id=${id}`)
}

/** 提交保存供应商资料 */
export function saveDetail(data) {
  return service.post(`/backend/supplier/detail`, data)
}

/** 移除供应商资料 */
export function removeDetail(data) {
  return service.post(`/backend/supplier/remove`, data)
}

/** 重置供应商密码 */
export function resetPassword(data) {
  return service.post(`/backend/supplier/reset`, data)
}

/** 更新供应商状态 */
export function updateStatus(data) {
  return service.put(`/backend/supplier/status`, data)
}

/** 获取商品列表 */
export function getGoodsList(params) {
  return service.get('/backend/supplier/goods/list', { params })
}

/** 获取商品详情 */
export function getGoodsDetail(goodsId) {
  return service.get(`/backend/supplier/goods/detail?goodsId=${goodsId}`)
}

/** 删除供应商申请删除的商品 */
export function removeGoods(params) {
  return service.delete(`/backend/supplier/goods/detail`, { params })
}

/** 更新商品状态 */
export function approveGoods(data) {
  return service.put(`/backend/supplier/goods/approve`, data)
}

/** 商品上架 */
export function putGoodOnsale(data) {
  return service.put(`/backend/supplier/goods/onsale`, data)
}

/** 获取未发货供应商列表 */
export function getUnshippedSuppliers(params) {
  return service.get(`/backend/supplier/order/${params.orderType}/unshipped?orderStatus=${params.orderStatus}`)
}
